<template>
  <div class="block">
    <el-carousel
      height="820px"
      :interval="interval"
    >
      <el-carousel-item
        v-for="item in propList"
        :key="item.id"
      >
        <h3 class="small">
          <img :src="item.url">
        </h3>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<style>
  .small {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center; /* 垂直居中 */
  }
  .small img{
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  .carousel-image-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */
  }
  .carousel-image {
    max-width: 100%; /* 图片最大宽度为容器宽度 */
    max-height: 100%; /* 图片最大高度为容器高度 */
    width: auto; /* 自动宽度，以保持比例 */
    height: auto; /* 自动高度，以保持比例 */
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
     background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6;
  }
  .el-carousel__item h3{
    opacity: 1;
  }
  .carousel-image {
    max-width: 100%;
    max-height: 100%;
  }

</style>

<script>
export default {
  data() {
    return {
      interval:3000
    }
  },
  props:['propList']
}
</script>